/* import __COLOCATED_TEMPLATE__ from './toggle.hbs'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import assert, { assertBoolean } from '@banking/ui/utils/assert';
let Toggle = (_class = class Toggle extends Component {
  get checked() {
    return this.args.checked ?? false;
  }
  get disabled() {
    return this.args.disabled ?? false;
  }
  onCheckedArgDidUpdate(element, args) {
    assert(args.length > 0);
    element.setSelection(assertBoolean(args[0]), {
      silent: true
    });
  }
  onDisabledArgDidUpdate(element, args) {
    assert(args.length > 0);
    element.setDisabled(assertBoolean(args[0]));
  }
  onToggleChange(event) {
    this.args.onToggleChange?.(event.detail.current);
  }
}, _applyDecoratedDescriptor(_class.prototype, "onCheckedArgDidUpdate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onCheckedArgDidUpdate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDisabledArgDidUpdate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onDisabledArgDidUpdate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onToggleChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onToggleChange"), _class.prototype), _class);
export { Toggle as default };